// import React, { useState, useEffect, useRef } from "react";

// interface CommentMarkerProps {
//   id: number;
//   percentX: number;
//   percentY: number;
//   text: string;
//   username?: string;
//   containerWidth: number;
//   containerHeight: number;
//   onMarkerClick?: (id: number) => void;
// }

// export const CommentMarker = ({
//   id,
//   percentX,
//   percentY,
//   text,
//   username,
//   containerWidth,
//   containerHeight,
//   onMarkerClick,
// }: CommentMarkerProps) => {
//   const [isHovering, setIsHovering] = useState(false);
//   const [isClicked, setIsClicked] = useState(false);
//   const [popupPosition, setPopupPosition] = useState<"right" | "left">("right");
//   const markerRef = useRef<HTMLDivElement>(null);
//   const popupRef = useRef<HTMLDivElement>(null);
//   const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);

//   // Calculate pixel position from percentage
//   const x = (percentX / 100) * containerWidth;
//   const y = (percentY / 100) * containerHeight;

//   // Determine if popup should be shown
//   const showPopup = isHovering || isClicked;

//   // Adjust popup position based on available space
//   useEffect(() => {
//     if (showPopup && popupRef.current) {
//       const popupWidth = 320; // Fixed popup width
//       const spaceRight = containerWidth - x;
//       const spaceLeft = x;

//       // Show on left if not enough space on right (need at least popupWidth + 48px)
//       if (spaceRight < popupWidth + 48 && spaceLeft > popupWidth + 48) {
//         setPopupPosition("left");
//       } else {
//         setPopupPosition("right");
//       }
//     }
//   }, [showPopup, x, containerWidth]);

//   // Close popup when clicking outside
//   useEffect(() => {
//     if (!isClicked) return;

//     const handleClickOutside = (event: MouseEvent) => {
//       if (
//         markerRef.current &&
//         !markerRef.current.contains(event.target as Node) &&
//         popupRef.current &&
//         !popupRef.current.contains(event.target as Node)
//       ) {
//         setIsClicked(false);
//       }
//     };

//     // Use capture phase to ensure we catch the click before other handlers
//     document.addEventListener("mousedown", handleClickOutside, true);
//     return () =>
//       document.removeEventListener("mousedown", handleClickOutside, true);
//   }, [isClicked]);

//   // Detect touch device
//   const isTouchDevice = () => {
//     return "ontouchstart" in window || navigator.maxTouchPoints > 0;
//   };

//   const handleMouseEnter = () => {
//     if (isTouchDevice()) return; // Disable hover on touch devices

//     // Clear any pending hide timeout
//     if (hoverTimeoutRef.current) {
//       clearTimeout(hoverTimeoutRef.current);
//       hoverTimeoutRef.current = null;
//     }

//     setIsHovering(true);
//   };

//   const handleMouseLeave = () => {
//     if (isTouchDevice()) return;

//     // Delay hiding to allow mouse to move to popup
//     hoverTimeoutRef.current = setTimeout(() => {
//       setIsHovering(false);
//     }, 100);
//   };

//   const handlePopupMouseEnter = () => {
//     if (isTouchDevice()) return;

//     // Clear hide timeout when mouse enters popup
//     if (hoverTimeoutRef.current) {
//       clearTimeout(hoverTimeoutRef.current);
//       hoverTimeoutRef.current = null;
//     }

//     setIsHovering(true);
//   };

//   const handlePopupMouseLeave = () => {
//     if (isTouchDevice()) return;

//     setIsHovering(false);
//   };

//   const handleMarkerClick = (e: React.MouseEvent) => {
//     e.stopPropagation(); // Prevent event from bubbling

//     // Toggle clicked state
//     setIsClicked((prev) => !prev);

//     // Clear hover state when clicking
//     setIsHovering(false);
//     if (hoverTimeoutRef.current) {
//       clearTimeout(hoverTimeoutRef.current);
//       hoverTimeoutRef.current = null;
//     }

//     // Notify parent component
//     onMarkerClick?.(id);
//   };

//   // Cleanup timeout on unmount
//   useEffect(() => {
//     return () => {
//       if (hoverTimeoutRef.current) {
//         clearTimeout(hoverTimeoutRef.current);
//       }
//     };
//   }, []);

//   return (
//     <>
//       <style>{`
//         @keyframes commentPopupFadeIn {
//           from {
//             opacity: 0;
//           }
//           to {
//             opacity: 1;
//           }
//         }

//         .toolbar-comment-marker {
//           transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//         }

//         .toolbar-comment-marker:hover {
//           transform: translate(-50%, 0%) scale(1.05);
//         }

//         .toolbar-comment-marker:active {
//           transform: translate(-50%, 0%) scale(0.95);
//         }

//         .toolbar-comment-popup {
//           animation: commentPopupFadeIn 0.2s ease forwards;
//         }
//       `}</style>

//       {/* Comment Marker Circle */}
//       <div
//         ref={markerRef}
//         className="toolbar-comment-marker"
//         style={{
//           position: "absolute",
//           left: `${percentX}%`,
//           top: `${percentY}%`,
//           width: "36px",
//           height: "36px",
//           background: "rgba(30, 30, 30, 0.85)",
//           backdropFilter: "blur(30px)",
//           WebkitBackdropFilter: "blur(30px)",
//           border: "1px solid rgba(255, 255, 255, 0.35)",
//           borderRadius: "50%",
//           cursor: "grab",
//           transform: isHovering
//             ? "translate(-50%, 0%) scale(1.05)"
//             : "translate(-50%, 0%)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "white",
//           fontSize: "16px",
//           fontWeight: 600,
//           zIndex: isClicked ? 1002 : 10,
//           userSelect: "none",
//           boxShadow: isHovering
//             ? "0 6px 20px rgba(0, 0, 0, 0.6)"
//             : "0 4px 14px rgba(0, 0, 0, 0.5)",
//           borderColor: isHovering
//             ? "rgba(255, 255, 255, 0.7)"
//             : "rgba(255, 255, 255, 0.35)",
//           WebkitTapHighlightColor: "transparent",
//         }}
//         onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//         onClick={handleMarkerClick}
//       >
//         {id}
//       </div>

//       {/* Comment Popup */}
//       {showPopup && text && (
//         <div
//           ref={popupRef}
//           className="toolbar-comment-popup"
//           style={{
//             position: "absolute",
//             left: popupPosition === "right" ? `${x + 18 + 12}px` : "auto",
//             right:
//               popupPosition === "left"
//                 ? `${containerWidth - x + 18 + 12}px`
//                 : "auto",
//             top: `${y}px`,
//             width: "320px",
//             minWidth: "320px",
//             maxWidth: "320px",
//             background: "rgba(30, 30, 30, 0.85)",
//             backdropFilter: "blur(30px)",
//             WebkitBackdropFilter: "blur(30px)",
//             border: "1px solid rgba(255, 255, 255, 0.35)",
//             borderRadius: "16px",
//             padding: "8px 12px",
//             boxShadow:
//               "0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)",
//             zIndex: 100,
//             pointerEvents: "auto",
//           }}
//           onMouseEnter={handlePopupMouseEnter}
//           onMouseLeave={handlePopupMouseLeave}
//           onClick={(e) => e.stopPropagation()}
//         >
//           {username && (
//             <div
//               style={{
//                 fontSize: "14px",
//                 lineHeight: "21px",
//                 color: "white",
//                 marginBottom: "4px",
//               }}
//             >
//               {username}
//             </div>
//           )}
//           <div
//             style={{
//               fontSize: "14px",
//               lineHeight: "21px",
//               color: "white",
//               wordWrap: "break-word",
//               wordBreak: "break-word",
//               whiteSpace: "pre-wrap",
//             }}
//           >
//             {text}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

import React, { useState, useEffect, useRef } from "react";
import AIIcon from "../../assets/icons/AI.svg";

interface CommentMarkerProps {
  id: number;
  percentX: number;
  percentY: number;
  text: string;
  username?: string;
  containerWidth: number;
  containerHeight: number;
  onMarkerClick?: (id: number) => void;
  onMarkerUnclick?: () => void;
  images?: string[];
  onImageClick?: (images: string[], startIndex: number) => void;
  profilePicture?: string;
}

// Helper function to render text with clickable links
const renderTextWithLinks = (text: string) => {
  // URL regex pattern
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "white",
            textDecoration: "underline",
            transition: "opacity 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = "0.8";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = "1";
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {part}
        </a>
      );
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
};

export const CommentMarker = ({
  id,
  percentX,
  percentY,
  text,
  username,
  containerWidth,
  containerHeight,
  onMarkerClick,
  onMarkerUnclick,
  images,
  onImageClick,
  profilePicture,
}: CommentMarkerProps) => {
  const [isHovering, setIsHovering] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [calculatedPosition, setCalculatedPosition] = useState<{
    left: number;
    top: number;
  }>({ left: 0, top: 0 });
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const markerRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const imagesContainerRef = useRef<HTMLDivElement>(null);
  const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const animationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const updateScrollButtons = (el: HTMLElement) => {
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  // Calculate pixel position from percentage
  const x = (percentX / 100) * containerWidth;
  const y = (percentY / 100) * containerHeight;

  // Determine if popup should be shown
  const showPopup = isHovering || isClicked;

  // Handle popup visibility with animation
  useEffect(() => {
    if (showPopup) {
      // Clear any pending hide animation
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
        animationTimeoutRef.current = null;
      }
      setIsAnimatingOut(false);
      setIsVisible(true);
    } else if (isVisible) {
      // Start hide animation
      setIsAnimatingOut(true);
      animationTimeoutRef.current = setTimeout(() => {
        setIsVisible(false);
        setIsAnimatingOut(false);
      }, 200); // Match animation duration
    }
  }, [showPopup, isVisible]);

  // Calculate popup position based on available space
  useEffect(() => {
    if (showPopup && isVisible) {
      const popupWidth = 320;
      const gap = 8;
      const margin = 10;
      const markerWidth = 34;
      const popupHeight = popupRef.current?.offsetHeight || 100;

      const spaceRight = containerWidth - x;
      const spaceLeft = x;

      let leftPos = 0;
      let topPos = 0;

      // Primary Strategy - Side Positioning
      const canFitRight = spaceRight >= popupWidth + gap;
      const canFitLeft = spaceLeft >= popupWidth + gap;

      if (canFitRight || canFitLeft) {
        // At least one side can fit
        if (canFitRight && (!canFitLeft || spaceRight >= spaceLeft)) {
          leftPos = x + markerWidth / 2 + gap;
        } else {
          leftPos = x - markerWidth / 2 - gap - popupWidth;
        }
        // Align to top of marker (align-items: start)
        const idealTop = y - markerWidth / 2;
        topPos = Math.max(
          margin,
          Math.min(idealTop, containerHeight - popupHeight - margin),
        );
      } else {
        // Fallback Strategy - Vertical Positioning
        const spaceTop = y;
        const spaceBottom = containerHeight - y;
        const canFitBelow = spaceBottom >= popupHeight + gap;

        if (canFitBelow || spaceBottom >= spaceTop) {
          topPos = y + markerWidth / 2 + gap;
        } else {
          topPos = y - markerWidth / 2 - gap - popupHeight;
        }
        // Center horizontally
        const idealLeft = x - popupWidth / 2;
        leftPos = Math.max(
          margin,
          Math.min(idealLeft, containerWidth - popupWidth - margin),
        );
      }

      setCalculatedPosition({ left: leftPos, top: topPos });
    }
  }, [showPopup, isVisible, x, y, containerWidth, containerHeight]);

  // Close popup when clicking outside and prevent event propagation
  useEffect(() => {
    if (!isClicked) return;

    const handleClickOutside = (event: MouseEvent) => {
      const clickedOutside =
        markerRef.current &&
        !markerRef.current.contains(event.target as Node) &&
        popupRef.current &&
        !popupRef.current.contains(event.target as Node);

      if (clickedOutside) {
        // Prevent the click from triggering other actions (like opening fullscreen)
        event.stopPropagation();
        event.preventDefault();
        setIsClicked(false);
        onMarkerUnclick?.();
      }
    };

    // Use capture phase to ensure we catch the click before other handlers
    document.addEventListener("mousedown", handleClickOutside, true);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [isClicked]);

  // Detect touch device
  const isTouchDevice = () => {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
  };

  const handleMouseEnter = () => {
    if (isTouchDevice()) return; // Disable hover on touch devices

    // Clear any pending hide timeout
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }

    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    if (isTouchDevice()) return;

    // Delay hiding to allow mouse to move to popup
    hoverTimeoutRef.current = setTimeout(() => {
      setIsHovering(false);
    }, 100);
  };

  const handlePopupMouseEnter = () => {
    if (isTouchDevice()) return;

    // Clear hide timeout when mouse enters popup
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }

    setIsHovering(true);
  };

  const handlePopupMouseLeave = () => {
    if (isTouchDevice()) return;

    setIsHovering(false);
  };

  const handleMarkerClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event from bubbling

    // Clear any pending hover timeouts
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }

    const wasClicked = isClicked;

    // Toggle clicked state
    setIsClicked((prev) => !prev);

    // Only clear hover state when unclicking (closing the popup)
    if (wasClicked) {
      setIsHovering(false);
    }

    // Notify parent component
    onMarkerClick?.(id);
  };

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
    };
  }, []);

  // Initialize scroll button state when images container appears
  useEffect(() => {
    if (
      isVisible &&
      images &&
      images.length > 0 &&
      imagesContainerRef.current
    ) {
      setTimeout(() => {
        if (imagesContainerRef.current) {
          updateScrollButtons(imagesContainerRef.current);
        }
      }, 100);
    }
  }, [isVisible, images]);

  return (
    <>
      <style>{`
        @keyframes commentPopupSlideIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes commentPopupSlideOut {
          from {
            opacity: 1;
            transform: translateY(0);
          }
          to {
            opacity: 0;
            transform: translateY(10px);
          }
        }

        .toolbar-comment-marker-outer {
          transition: all 0.2s ease;
        }

        .toolbar-comment-marker-outer:hover {
          transform: translate(-50%, -50%) scale(1.05);
        }

        .toolbar-comment-marker-outer:hover .toolbar-comment-marker {
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.6);
        }

        .toolbar-comment-popup-hover {
          animation: commentPopupSlideIn 0.2s ease forwards;
        }

        .toolbar-comment-popup-hover.animating-out {
          animation: commentPopupSlideOut 0.2s ease forwards;
        }
      `}</style>

      {/* Comment Marker Circle */}
      <div
        ref={markerRef}
        className="toolbar-comment-marker-outer"
        style={{
          position: "absolute",
          left: `${percentX}%`,
          top: `${percentY}%`,
          width: "34px",
          height: "34px",
          background: "rgba(29, 29, 29, 0.8)",
          borderRadius: "5px 50% 50% 50%",
          padding: "1px",
          cursor: "pointer",
          transform: "translate(-50%, -50%)",
          zIndex: isHovering ? 105 : isClicked ? 103 : 101,
          userSelect: "none",
          WebkitTapHighlightColor: "transparent",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleMarkerClick}
      >
        <div
          className="toolbar-comment-marker"
          style={{
            width: "100%",
            height: "100%",
            background: "rgba(30, 30, 30, 0.85)",
            backdropFilter: "blur(30px)",
            WebkitBackdropFilter: "blur(30px)",
            border: "0.5px solid rgba(255, 255, 255, 0.35)",
            borderRadius: "5px 50% 50% 50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "14px",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.5)",
            transition: "all 0.2s ease",
            boxSizing: "border-box",
          }}
        >
          {id}
        </div>
      </div>

      {/* Comment Popup */}
      {isVisible && text && (
        <div
          ref={popupRef}
          className={`toolbar-comment-popup-hover ${isAnimatingOut ? "animating-out" : ""}`}
          style={{
            position: "absolute",
            left: `${calculatedPosition.left}px`,
            top: `${calculatedPosition.top}px`,
            width: "320px",
            minWidth: "320px",
            maxWidth: "320px",
            background: "rgba(29, 29, 29, 0.8)",
            backdropFilter: "blur(40px)",
            WebkitBackdropFilter: "blur(40px)",
            borderRadius: "19px",
            padding: "0",
            boxShadow: "none",
            zIndex: isHovering ? 106 : isClicked ? 104 : 100,
            pointerEvents: "auto",
            cursor: "pointer",
            opacity: 0,
          }}
          onMouseEnter={handlePopupMouseEnter}
          onMouseLeave={handlePopupMouseLeave}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              width: "100%",
              borderRadius: "19px",
              display: "flex",
              backgroundColor: "rgba(29, 29, 29, 0.8)",
              padding: "1px",
              boxShadow: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                gap: "8px",
                width: "100%",
                border: "0.5px solid rgba(255, 255, 255, 0.35)",
                borderRadius: "18px",
                boxSizing: "border-box",
                paddingTop: "9px",
                paddingBottom: images && images.length > 0 ? "0" : "9px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0 9px",
                  paddingRight: "14px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {username === "AI agent" ? (
                    <img
                      src={AIIcon}
                      className="w-[24px] h-[24px] rounded-[50%]"
                    />
                  ) : profilePicture ? (
                    <img
                      src={profilePicture}
                      className="border-[1px] w-[24px] h-[24px] border-white/[0.32] rounded-[50%]"
                    />
                  ) : null}
                  <div
                    style={{
                      fontSize: "13px",
                      lineHeight: "19px",
                      color: "white",
                    }}
                  >
                    {username || "User"}
                  </div>
                </div>
              </div>
              <div
                style={{
                  fontSize: "14px",
                  lineHeight: "21px",
                  color: "white",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "pre-wrap",
                  padding: "0 12px",
                }}
              >
                {renderTextWithLinks(text)}
              </div>
              {images && images.length > 0 && (
                <div style={{ position: "relative", padding: "0 0 9px 0" }}>
                  {canScrollLeft && (
                    <button
                      type="button"
                      className="absolute left-[7px] top-1/2 -translate-y-1/2 z-10 w-[24px] h-[24px] bg-gray-400/[0.32] backdrop-blur-[24px] rounded-[10px] flex items-center justify-center cursor-pointer transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        imagesContainerRef.current?.scrollBy({
                          left: -(65 + 6),
                          behavior: "smooth",
                        });
                      }}
                    >
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                        <path
                          d="M5 1L2 4L5 7"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  )}
                  <div
                    ref={imagesContainerRef}
                    style={{
                      display: "flex",
                      gap: "6px",
                      overflowX: "auto",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                      padding: "0 12px",
                    }}
                    onScroll={(e) => updateScrollButtons(e.currentTarget)}
                  >
                    {images.map((imageUrl: string, imgIdx: number) => (
                      <div
                        key={imgIdx}
                        style={{
                          width: "65px",
                          height: "65px",
                          flexShrink: 0,
                          border: "1px solid rgba(255, 255, 255, 0.07)",
                          borderRadius: "10px",
                          overflow: "hidden",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (onImageClick && images) {
                            onImageClick(images, imgIdx);
                          } else {
                            window.open(imageUrl, "_blank");
                          }
                        }}
                      >
                        <img
                          src={imageUrl}
                          alt={`Comment image ${imgIdx + 1}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  {canScrollRight && (
                    <button
                      type="button"
                      className="absolute right-[7px] top-1/2 -translate-y-1/2 z-10 w-[24px] h-[24px] bg-gray-400/[0.32] backdrop-blur-[24px] rounded-[10px] flex items-center justify-center cursor-pointer transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        imagesContainerRef.current?.scrollBy({
                          left: 65 + 6,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                        <path
                          d="M3 1L6 4L3 7"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
